import { useEffect } from 'react';
import LoadingSpinner from "@atlassian/community-library/dist/components/loading-spinner";

type ExternalRedirectProps = {
  to: string;
};

const ExternalRedirect = ({ to }: ExternalRedirectProps) => {
  useEffect(() => {
    console.log('[ExternalRedirect] Redirecting to:', to);
    
    // Try multiple redirect methods in order of preference
    try {
      // Method 1: Use replace for cleaner history
      window.location.replace(to);
    } catch (error) {
      console.error('[ExternalRedirect] Error with replace, trying assign:', error);
      try {
        // Method 2: Fallback to assign
        window.location.assign(to);
      } catch (error) {
        console.error('[ExternalRedirect] Error with assign, trying href:', error);
        // Method 3: Last resort - direct href assignment
        window.location.href = to;
      }
    }
  }, [to]);
  
  return <LoadingSpinner />;
};

export default ExternalRedirect; 